import { cva, type VariantProps } from 'class-variance-authority';
import { useMemo, type PropsWithChildren } from 'react';
import { BlogArticleContent } from './BlogArticleContent';
import { BlogArticleHeader } from './BlogArticleHeader';

const variants = cva( 'flex', {
  variants: {
    alignment: {
      default: 'flex-col gap-2.5',
      left: 'flex-col gap-2.5 md:flex-row md:[&_img]:max-w-[230px] md:gap-5 '
    }
  }
} )

type BlogArticleProps = PropsWithChildren<VariantProps<typeof variants>>;

export const BlogArticle = ( { children, alignment = 'default' }: BlogArticleProps ) => {

  const Components = useMemo ( () => {
    return Array.isArray( children ) ? children : [ children ];
  }, [ children ] );

  const Content = Components.find( c => c?.type?.displayName === BlogArticleContent.displayName );

  const Header = Components.find( c => c?.type?.displayName === BlogArticleHeader.displayName );

  return (
    <article className={ variants( { alignment } ) }>
      { Header }
      { Content }
    </article>
  )
}
BlogArticle.displayName = 'BlogArticle';
